// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dimensions-page {
  --page-max: 1180px;
  --page-gutter: 28px;
  --ink-soft: #405149;
  --neutral-label: #6A6E67;
  --line: rgba(19, 35, 29, 0.09);
  --shadow-card: 0 18px 48px rgba(18, 34, 29, 0.045);

  --cuerpo: #242E7B;
  --mente: #5D8ABA;
  --energia: #53A96E;
  --conciencia: #574093;

  overflow: hidden;
  background: var(--bg-page, #EFF0EC);
  color: var(--text-main, #13231D);
}

.dimensions-page .page-container {
  width: min(100%, var(--page-max));
  margin: 0 auto;
  padding-left: var(--page-gutter);
  padding-right: var(--page-gutter);
}

.dimensions-page .page-section {
  padding-top: 80px;
}

.dimensions-page .section-heading {
  max-width: 790px;
  margin-bottom: 28px;
}

.dimensions-page .eyebrow {
  display: inline-block;
  margin: 0 0 12px;
  padding-left: 0;
  color: var(--primary, #82B194);
  font-size: 12px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: .16em;
  text-transform: uppercase;
}

.dimensions-page .section-heading h2 {
  margin: 0;
  font-size: clamp(30px, 4vw, 44px);
  line-height: 1.06;
  letter-spacing: -.04em;
}

.dimensions-page .section-copy {
  margin: 13px 0 0;
  color: var(--text-muted, #4F5F59);
  font-size: 16px;
  line-height: 1.7;
}

.dimensions-page .page-hero {
  padding: 76px 0 24px;
}

.dimensions-page .hero-card {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(280px, .55fr);
  gap: 52px;
  align-items: start;
  padding: 58px;
  border: 1px solid var(--line);
  border-radius: 32px;
  background: var(--bg-surface, #F7F5F1);
  box-shadow: var(--shadow-card);
}

.dimensions-page .hero-card h1 {
  margin: 0;
  max-width: 810px;
  font-size: clamp(44px, 6vw, 68px);
  line-height: .99;
  letter-spacing: -.052em;
}

.dimensions-page .hero-lead {
  margin: 22px 0 0;
  max-width: 760px;
  color: var(--ink-soft);
  font-size: 18px;
  line-height: 1.68;
}

.dimensions-page .hero-actions {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  margin-top: 30px;
}

.dimensions-page .dim-btn-primary {
  background: var(--primary, #82B194);
  border-color: transparent;
  color: #fff;
  min-height: 48px;
  padding: 0 22px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.dimensions-page .dim-btn-primary:hover {
  background: var(--primary-hover, #5E806C);
  color: #fff;
}

.dimensions-page .dim-btn-secondary {
  background: transparent;
  border: 1px solid var(--primary, #82B194);
  color: var(--primary, #82B194);
  min-height: 48px;
  padding: 0 22px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.dimensions-page .dim-btn-secondary:hover {
  background: rgba(130, 177, 148, .10);
  border-color: var(--primary-hover, #5E806C);
  color: var(--primary-hover, #5E806C);
}

.dimensions-page .hero-aside {
  display: grid;
  justify-items: center;
  padding: 4px 0 2px 34px;
  border-left: 1px solid var(--line);
}

.dimensions-page .hero-flower {
  width: min(100%, 270px);
  margin: 0;
  text-align: center;
}

.dimensions-page .hero-flower img {
  width: 100%;
  height: auto;
  filter: drop-shadow(0 20px 28px rgba(19, 35, 29, .09));
}

.dimensions-page .hero-flower figcaption {
  margin: 12px auto 0;
  max-width: 29ch;
  color: var(--text-muted, #4F5F59);
  font-size: 11px;
  line-height: 1.55;
}

.dimensions-page .hero-stat {
  width: 100%;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--line);
  text-align: left;
}

.dimensions-page .hero-stat strong {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.4;
}

.dimensions-page .hero-stat p {
  margin: 0;
  color: var(--text-muted, #4F5F59);
  font-size: 13px;
  line-height: 1.7;
}

.dimensions-page .hero-aside .catalog-total {
  display: block;
  margin-bottom: 14px;
  color: var(--text-main, #13231D);
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -.04em;
}

.dimensions-page .dimension-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.dimensions-page .dimension-card {
  position: relative;
  min-height: 190px;
  padding: 24px;
  border: 1px solid var(--accent-border);
  border-radius: 24px;
  background: linear-gradient(180deg, var(--accent-soft), var(--bg-surface, #F7F5F1) 54%);
  box-shadow: var(--shadow-card);
}

.dimensions-page .dimension-card h3 {
  margin: 18px 0 8px;
  font-size: 24px;
  line-height: 1.15;
  letter-spacing: -.03em;
}

.dimensions-page .dimension-card p {
  margin: 0;
  color: var(--text-muted, #4F5F59);
  font-size: 13px;
  line-height: 1.66;
}

.dimensions-page .dimension-count {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent-ink);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .02em;
}

.dimensions-page .catalog-section {
  padding-bottom: 88px;
}

.dimensions-page .catalog-shell {
  padding: 22px;
  border: 1px solid var(--line);
  border-radius: 28px;
  background: rgba(247, 245, 241, .78);
  box-shadow: var(--shadow-card);
}

.dimensions-page .toolbar {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) auto;
  gap: 12px;
  align-items: center;
  margin-bottom: 18px;
}

.dimensions-page .search-wrap {
  position: relative;
}

.dimensions-page .search-wrap::after {
  content: "⌕";
  position: absolute;
  top: 50%;
  right: 17px;
  transform: translateY(-52%);
  color: var(--neutral-label);
  font-size: 23px;
  line-height: 1;
  pointer-events: none;
}

.dimensions-page .search {
  width: 100%;
  min-height: 52px;
  padding: 0 50px 0 17px;
  border: 1px solid rgba(19, 35, 29, .13);
  border-radius: 16px;
  background: #fff;
  color: var(--text-main, #13231D);
  font: inherit;
  outline: none;
}

.dimensions-page .search::placeholder {
  color: rgba(19, 35, 29, .47);
}

.dimensions-page .search:focus {
  border-color: var(--primary, #82B194);
  box-shadow: 0 0 0 4px rgba(130, 177, 148, .14);
}

.dimensions-page .filters {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.dimensions-page .filter {
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid rgba(19, 35, 29, .13);
  border-radius: 999px;
  background: transparent;
  color: var(--text-main, #13231D);
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background .18s ease, border-color .18s ease, transform .18s ease;
}

.dimensions-page .filter:hover {
  transform: translateY(-1px);
  border-color: rgba(19, 35, 29, .28);
}

.dimensions-page .filter:focus-visible {
  outline: 2px solid rgba(130, 177, 148, .36);
  outline-offset: 2px;
}

.dimensions-page .filter[data-dim="todas"],
.dimensions-page .filter.is-active[data-dim="todas"] {
  border-color: var(--primary, #82B194);
  background: transparent;
  color: var(--primary, #82B194);
  box-shadow: none;
}

.dimensions-page .filter[data-dim="todas"]:hover {
  border-color: var(--primary-hover, #5E806C);
  background: rgba(130, 177, 148, .10);
  color: var(--primary-hover, #5E806C);
}

.dimensions-page .filter[data-dim="cuerpo"] {
  --filter-accent: #242E7B;
  --filter-soft: rgba(36, 46, 123, .09);
  --filter-border: rgba(36, 46, 123, .24);
}

.dimensions-page .filter[data-dim="mente"] {
  --filter-accent: #5D8ABA;
  --filter-soft: rgba(93, 138, 186, .11);
  --filter-border: rgba(93, 138, 186, .28);
}

.dimensions-page .filter[data-dim="energia"] {
  --filter-accent: #53A96E;
  --filter-soft: rgba(83, 169, 110, .11);
  --filter-border: rgba(83, 169, 110, .28);
}

.dimensions-page .filter[data-dim="conciencia"] {
  --filter-accent: #574093;
  --filter-soft: rgba(87, 64, 147, .10);
  --filter-border: rgba(87, 64, 147, .26);
}

.dimensions-page .filter[data-dim]:not([data-dim="todas"]) {
  border-color: var(--filter-border);
  background: var(--filter-soft);
  color: var(--filter-accent);
}

.dimensions-page .filter[data-dim]:not([data-dim="todas"]):hover {
  border-color: var(--filter-accent);
  background: var(--filter-soft);
  color: var(--filter-accent);
}

.dimensions-page .filter.is-active[data-dim]:not([data-dim="todas"]) {
  border-color: var(--filter-accent);
  background: var(--filter-accent);
  color: #fff;
  box-shadow: none;
}

.dimensions-page .catalog-status {
  margin: -2px 0 2px;
  color: var(--neutral-label);
  font-size: 11px;
  line-height: 1.5;
}

.dimensions-page .dimension-section {
  margin-top: 24px;
}

.dimensions-page .dimension-title {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0 0 10px;
  padding: 9px 12px;
  border: 1px solid var(--accent-border);
  border-radius: 12px;
  background: linear-gradient(90deg, var(--accent-soft), rgba(247, 245, 241, .55));
  color: var(--accent-ink);
  font-size: 20px;
  line-height: 1.25;
  letter-spacing: -.025em;
}

.dimensions-page .dimension-dot {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: var(--accent);
}

.dimensions-page .category-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  align-items: start;
}

.dimensions-page .category {
  overflow: hidden;
  border: 1px solid var(--accent-border);
  border-radius: 14px;
  background: linear-gradient(90deg, var(--accent-soft), var(--bg-surface, #F7F5F1) 38%);
}

.dimensions-page .category[open] {
  border-color: var(--accent);
  box-shadow: 0 12px 28px rgba(18, 34, 29, .055);
}

.dimensions-page .category summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 52px;
  padding: 11px 13px;
  list-style: none;
  cursor: pointer;
}

.dimensions-page .category summary::-webkit-details-marker {
  display: none;
}

.dimensions-page .category-name {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.38;
}

.dimensions-page .plus {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 23px;
  height: 23px;
  border: 1px solid var(--accent-border);
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent-ink);
  font-size: 13px;
  font-weight: 800;
  transition: transform .18s ease;
}

.dimensions-page .category[open] .plus {
  transform: rotate(45deg);
}

.dimensions-page .category-body {
  padding: 0 13px 13px;
  color: var(--text-muted, #4F5F59);
  font-size: 12px;
  line-height: 1.62;
  font-weight: 300;
  font-family: "Sora", sans-serif !important;
}

.dimensions-page .category-body p {
  margin: 0;
  font-weight: 300;
  font-family: "Sora", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 12px;
  color: #5F726B;
}

.dimensions-page .category-body p strong {
  color: #405149 !important;
}


.dimensions-page .category-body strong {
  font-weight: 600;
}

.dimensions-page .related {
  margin-top: 10px !important;
  color: var(--ink-soft);
}

.dimensions-page .empty {
  padding: 34px 18px;
  text-align: center;
  color: var(--text-muted, #4F5F59);
}

.dimensions-page .legal-note {
  margin-top: 24px;
  padding: 18px 20px;
  border: 1px solid rgba(198, 167, 109, .28);
  border-radius: 18px;
  background: rgba(198, 167, 109, .1);
  color: #574A31;
  font-size: 13px;
  line-height: 1.68;
}

@media (max-width: 1000px) {
  .dimensions-page .hero-card {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .dimensions-page .hero-aside {
    grid-template-columns: minmax(180px, 260px) minmax(0, 1fr);
    gap: 28px;
    align-items: center;
    justify-items: start;
    padding: 28px 0 0;
    border-top: 1px solid var(--line);
    border-left: 0;
  }

  .dimensions-page .hero-stat {
    margin: 0;
    padding: 0;
    border-top: 0;
  }

  .dimensions-page .dimension-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .dimensions-page .toolbar {
    grid-template-columns: 1fr;
  }

  .dimensions-page .filters {
    justify-content: flex-start;
  }

  .dimensions-page .category-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .dimensions-page {
    --page-gutter: 20px;
  }

  .dimensions-page .page-section {
    padding-top: 60px;
  }

  .dimensions-page .page-hero {
    padding-top: 40px;
  }

  .dimensions-page .hero-card {
    padding: 34px 24px;
    border-radius: 26px;
  }

  .dimensions-page .hero-lead {
    font-size: 16px;
  }

  .dimensions-page .hero-aside {
    grid-template-columns: 1fr;
    justify-items: center;
  }

  .dimensions-page .hero-stat {
    width: min(100%, 420px);
    padding-top: 20px;
    border-top: 1px solid var(--line);
    text-align: center;
  }

  .dimensions-page .hero-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .dimensions-page .dim-btn-primary,
  .dimensions-page .dim-btn-secondary {
    width: 100%;
  }

  .dimensions-page .catalog-shell {
    padding: 18px;
  }
}

@media (max-width: 520px) {
  .dimensions-page .dimension-grid {
    grid-template-columns: 1fr;
  }

  .dimensions-page .dimension-card {
    min-height: 0;
  }

  .dimensions-page .hero-actions {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }

  .dimensions-page .filters {
    gap: 7px;
  }

  .dimensions-page .filter {
    padding: 0 12px;
  }

  .dimensions-page .category-list {
    grid-template-columns: 1fr;
  }

  .dimensions-page .catalog-section {
    padding-bottom: 64px;
  }
}

/* Nuevos estilos de V23 */
.dimensions-page .verification-note {
  margin: 0 2px;
  color: #6b7972;
  font-size: 10.5px;
  line-height: 1.55;
  max-width: 76ch;
}
.dimensions-page .verification-note strong {
  color: #52675b;
  font-weight: 750;
}
.dimensions-page .catalog-contact {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-top: 24px;
  padding: 18px 20px;
  border: 1px solid rgba(130,177,148,.28);
  border-radius: 18px;
  background: rgba(130,177,148,.09);
}
.dimensions-page .catalog-contact-copy {
  margin: 0;
  color: var(--text-muted);
  font-size: 13px;
  line-height: 1.65;
}
.dimensions-page .catalog-contact-copy strong {
  color: var(--text-main);
}
.dimensions-page .catalog-contact .dim-btn-secondary {
  flex: 0 0 auto;
  min-height: 40px;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@media(max-width:760px){
  .dimensions-page .catalog-contact {
    align-items: flex-start;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/DimensionsCatalogPage/DimensionsCatalogPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,kDAAkD;;EAElD,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;;EAErB,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,uFAAuF;EACvF,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,8BAA8B;EAC9B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,gFAAgF;EAChF,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,sFAAsF;AACxF;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,8BAA8B;EAC9B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oGAAoG;EACpG,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0DAA0D;IAC1D,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":[".dimensions-page {\n  --page-max: 1180px;\n  --page-gutter: 28px;\n  --ink-soft: #405149;\n  --neutral-label: #6A6E67;\n  --line: rgba(19, 35, 29, 0.09);\n  --shadow-card: 0 18px 48px rgba(18, 34, 29, 0.045);\n\n  --cuerpo: #242E7B;\n  --mente: #5D8ABA;\n  --energia: #53A96E;\n  --conciencia: #574093;\n\n  overflow: hidden;\n  background: var(--bg-page, #EFF0EC);\n  color: var(--text-main, #13231D);\n}\n\n.dimensions-page .page-container {\n  width: min(100%, var(--page-max));\n  margin: 0 auto;\n  padding-left: var(--page-gutter);\n  padding-right: var(--page-gutter);\n}\n\n.dimensions-page .page-section {\n  padding-top: 80px;\n}\n\n.dimensions-page .section-heading {\n  max-width: 790px;\n  margin-bottom: 28px;\n}\n\n.dimensions-page .eyebrow {\n  display: inline-block;\n  margin: 0 0 12px;\n  padding-left: 0;\n  color: var(--primary, #82B194);\n  font-size: 12px;\n  line-height: 1.2;\n  font-weight: 800;\n  letter-spacing: .16em;\n  text-transform: uppercase;\n}\n\n.dimensions-page .section-heading h2 {\n  margin: 0;\n  font-size: clamp(30px, 4vw, 44px);\n  line-height: 1.06;\n  letter-spacing: -.04em;\n}\n\n.dimensions-page .section-copy {\n  margin: 13px 0 0;\n  color: var(--text-muted, #4F5F59);\n  font-size: 16px;\n  line-height: 1.7;\n}\n\n.dimensions-page .page-hero {\n  padding: 76px 0 24px;\n}\n\n.dimensions-page .hero-card {\n  display: grid;\n  grid-template-columns: minmax(0, 1.45fr) minmax(280px, .55fr);\n  gap: 52px;\n  align-items: start;\n  padding: 58px;\n  border: 1px solid var(--line);\n  border-radius: 32px;\n  background: var(--bg-surface, #F7F5F1);\n  box-shadow: var(--shadow-card);\n}\n\n.dimensions-page .hero-card h1 {\n  margin: 0;\n  max-width: 810px;\n  font-size: clamp(44px, 6vw, 68px);\n  line-height: .99;\n  letter-spacing: -.052em;\n}\n\n.dimensions-page .hero-lead {\n  margin: 22px 0 0;\n  max-width: 760px;\n  color: var(--ink-soft);\n  font-size: 18px;\n  line-height: 1.68;\n}\n\n.dimensions-page .hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  flex-wrap: wrap;\n  margin-top: 30px;\n}\n\n.dimensions-page .dim-btn-primary {\n  background: var(--primary, #82B194);\n  border-color: transparent;\n  color: #fff;\n  min-height: 48px;\n  padding: 0 22px;\n  border-radius: 20px;\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.dimensions-page .dim-btn-primary:hover {\n  background: var(--primary-hover, #5E806C);\n  color: #fff;\n}\n\n.dimensions-page .dim-btn-secondary {\n  background: transparent;\n  border: 1px solid var(--primary, #82B194);\n  color: var(--primary, #82B194);\n  min-height: 48px;\n  padding: 0 22px;\n  border-radius: 20px;\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.dimensions-page .dim-btn-secondary:hover {\n  background: rgba(130, 177, 148, .10);\n  border-color: var(--primary-hover, #5E806C);\n  color: var(--primary-hover, #5E806C);\n}\n\n.dimensions-page .hero-aside {\n  display: grid;\n  justify-items: center;\n  padding: 4px 0 2px 34px;\n  border-left: 1px solid var(--line);\n}\n\n.dimensions-page .hero-flower {\n  width: min(100%, 270px);\n  margin: 0;\n  text-align: center;\n}\n\n.dimensions-page .hero-flower img {\n  width: 100%;\n  height: auto;\n  filter: drop-shadow(0 20px 28px rgba(19, 35, 29, .09));\n}\n\n.dimensions-page .hero-flower figcaption {\n  margin: 12px auto 0;\n  max-width: 29ch;\n  color: var(--text-muted, #4F5F59);\n  font-size: 11px;\n  line-height: 1.55;\n}\n\n.dimensions-page .hero-stat {\n  width: 100%;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid var(--line);\n  text-align: left;\n}\n\n.dimensions-page .hero-stat strong {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.dimensions-page .hero-stat p {\n  margin: 0;\n  color: var(--text-muted, #4F5F59);\n  font-size: 13px;\n  line-height: 1.7;\n}\n\n.dimensions-page .hero-aside .catalog-total {\n  display: block;\n  margin-bottom: 14px;\n  color: var(--text-main, #13231D);\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: -.04em;\n}\n\n.dimensions-page .dimension-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.dimensions-page .dimension-card {\n  position: relative;\n  min-height: 190px;\n  padding: 24px;\n  border: 1px solid var(--accent-border);\n  border-radius: 24px;\n  background: linear-gradient(180deg, var(--accent-soft), var(--bg-surface, #F7F5F1) 54%);\n  box-shadow: var(--shadow-card);\n}\n\n.dimensions-page .dimension-card h3 {\n  margin: 18px 0 8px;\n  font-size: 24px;\n  line-height: 1.15;\n  letter-spacing: -.03em;\n}\n\n.dimensions-page .dimension-card p {\n  margin: 0;\n  color: var(--text-muted, #4F5F59);\n  font-size: 13px;\n  line-height: 1.66;\n}\n\n.dimensions-page .dimension-count {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: var(--accent-soft);\n  color: var(--accent-ink);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: .02em;\n}\n\n.dimensions-page .catalog-section {\n  padding-bottom: 88px;\n}\n\n.dimensions-page .catalog-shell {\n  padding: 22px;\n  border: 1px solid var(--line);\n  border-radius: 28px;\n  background: rgba(247, 245, 241, .78);\n  box-shadow: var(--shadow-card);\n}\n\n.dimensions-page .toolbar {\n  display: grid;\n  grid-template-columns: minmax(260px, 1fr) auto;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.dimensions-page .search-wrap {\n  position: relative;\n}\n\n.dimensions-page .search-wrap::after {\n  content: \"⌕\";\n  position: absolute;\n  top: 50%;\n  right: 17px;\n  transform: translateY(-52%);\n  color: var(--neutral-label);\n  font-size: 23px;\n  line-height: 1;\n  pointer-events: none;\n}\n\n.dimensions-page .search {\n  width: 100%;\n  min-height: 52px;\n  padding: 0 50px 0 17px;\n  border: 1px solid rgba(19, 35, 29, .13);\n  border-radius: 16px;\n  background: #fff;\n  color: var(--text-main, #13231D);\n  font: inherit;\n  outline: none;\n}\n\n.dimensions-page .search::placeholder {\n  color: rgba(19, 35, 29, .47);\n}\n\n.dimensions-page .search:focus {\n  border-color: var(--primary, #82B194);\n  box-shadow: 0 0 0 4px rgba(130, 177, 148, .14);\n}\n\n.dimensions-page .filters {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.dimensions-page .filter {\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid rgba(19, 35, 29, .13);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--text-main, #13231D);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background .18s ease, border-color .18s ease, transform .18s ease;\n}\n\n.dimensions-page .filter:hover {\n  transform: translateY(-1px);\n  border-color: rgba(19, 35, 29, .28);\n}\n\n.dimensions-page .filter:focus-visible {\n  outline: 2px solid rgba(130, 177, 148, .36);\n  outline-offset: 2px;\n}\n\n.dimensions-page .filter[data-dim=\"todas\"],\n.dimensions-page .filter.is-active[data-dim=\"todas\"] {\n  border-color: var(--primary, #82B194);\n  background: transparent;\n  color: var(--primary, #82B194);\n  box-shadow: none;\n}\n\n.dimensions-page .filter[data-dim=\"todas\"]:hover {\n  border-color: var(--primary-hover, #5E806C);\n  background: rgba(130, 177, 148, .10);\n  color: var(--primary-hover, #5E806C);\n}\n\n.dimensions-page .filter[data-dim=\"cuerpo\"] {\n  --filter-accent: #242E7B;\n  --filter-soft: rgba(36, 46, 123, .09);\n  --filter-border: rgba(36, 46, 123, .24);\n}\n\n.dimensions-page .filter[data-dim=\"mente\"] {\n  --filter-accent: #5D8ABA;\n  --filter-soft: rgba(93, 138, 186, .11);\n  --filter-border: rgba(93, 138, 186, .28);\n}\n\n.dimensions-page .filter[data-dim=\"energia\"] {\n  --filter-accent: #53A96E;\n  --filter-soft: rgba(83, 169, 110, .11);\n  --filter-border: rgba(83, 169, 110, .28);\n}\n\n.dimensions-page .filter[data-dim=\"conciencia\"] {\n  --filter-accent: #574093;\n  --filter-soft: rgba(87, 64, 147, .10);\n  --filter-border: rgba(87, 64, 147, .26);\n}\n\n.dimensions-page .filter[data-dim]:not([data-dim=\"todas\"]) {\n  border-color: var(--filter-border);\n  background: var(--filter-soft);\n  color: var(--filter-accent);\n}\n\n.dimensions-page .filter[data-dim]:not([data-dim=\"todas\"]):hover {\n  border-color: var(--filter-accent);\n  background: var(--filter-soft);\n  color: var(--filter-accent);\n}\n\n.dimensions-page .filter.is-active[data-dim]:not([data-dim=\"todas\"]) {\n  border-color: var(--filter-accent);\n  background: var(--filter-accent);\n  color: #fff;\n  box-shadow: none;\n}\n\n.dimensions-page .catalog-status {\n  margin: -2px 0 2px;\n  color: var(--neutral-label);\n  font-size: 11px;\n  line-height: 1.5;\n}\n\n.dimensions-page .dimension-section {\n  margin-top: 24px;\n}\n\n.dimensions-page .dimension-title {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin: 0 0 10px;\n  padding: 9px 12px;\n  border: 1px solid var(--accent-border);\n  border-radius: 12px;\n  background: linear-gradient(90deg, var(--accent-soft), rgba(247, 245, 241, .55));\n  color: var(--accent-ink);\n  font-size: 20px;\n  line-height: 1.25;\n  letter-spacing: -.025em;\n}\n\n.dimensions-page .dimension-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 999px;\n  background: var(--accent);\n}\n\n.dimensions-page .category-list {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  align-items: start;\n}\n\n.dimensions-page .category {\n  overflow: hidden;\n  border: 1px solid var(--accent-border);\n  border-radius: 14px;\n  background: linear-gradient(90deg, var(--accent-soft), var(--bg-surface, #F7F5F1) 38%);\n}\n\n.dimensions-page .category[open] {\n  border-color: var(--accent);\n  box-shadow: 0 12px 28px rgba(18, 34, 29, .055);\n}\n\n.dimensions-page .category summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 52px;\n  padding: 11px 13px;\n  list-style: none;\n  cursor: pointer;\n}\n\n.dimensions-page .category summary::-webkit-details-marker {\n  display: none;\n}\n\n.dimensions-page .category-name {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.38;\n}\n\n.dimensions-page .plus {\n  display: grid;\n  flex: 0 0 auto;\n  place-items: center;\n  width: 23px;\n  height: 23px;\n  border: 1px solid var(--accent-border);\n  border-radius: 999px;\n  background: var(--accent-soft);\n  color: var(--accent-ink);\n  font-size: 13px;\n  font-weight: 800;\n  transition: transform .18s ease;\n}\n\n.dimensions-page .category[open] .plus {\n  transform: rotate(45deg);\n}\n\n.dimensions-page .category-body {\n  padding: 0 13px 13px;\n  color: var(--text-muted, #4F5F59);\n  font-size: 12px;\n  line-height: 1.62;\n  font-weight: 300;\n  font-family: \"Sora\", sans-serif !important;\n}\n\n.dimensions-page .category-body p {\n  margin: 0;\n  font-weight: 300;\n  font-family: \"Sora\", system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif !important;\n  font-size: 12px;\n  color: #5F726B;\n}\n\n.dimensions-page .category-body p strong {\n  color: #405149 !important;\n}\n\n\n.dimensions-page .category-body strong {\n  font-weight: 600;\n}\n\n.dimensions-page .related {\n  margin-top: 10px !important;\n  color: var(--ink-soft);\n}\n\n.dimensions-page .empty {\n  padding: 34px 18px;\n  text-align: center;\n  color: var(--text-muted, #4F5F59);\n}\n\n.dimensions-page .legal-note {\n  margin-top: 24px;\n  padding: 18px 20px;\n  border: 1px solid rgba(198, 167, 109, .28);\n  border-radius: 18px;\n  background: rgba(198, 167, 109, .1);\n  color: #574A31;\n  font-size: 13px;\n  line-height: 1.68;\n}\n\n@media (max-width: 1000px) {\n  .dimensions-page .hero-card {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n\n  .dimensions-page .hero-aside {\n    grid-template-columns: minmax(180px, 260px) minmax(0, 1fr);\n    gap: 28px;\n    align-items: center;\n    justify-items: start;\n    padding: 28px 0 0;\n    border-top: 1px solid var(--line);\n    border-left: 0;\n  }\n\n  .dimensions-page .hero-stat {\n    margin: 0;\n    padding: 0;\n    border-top: 0;\n  }\n\n  .dimensions-page .dimension-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .dimensions-page .toolbar {\n    grid-template-columns: 1fr;\n  }\n\n  .dimensions-page .filters {\n    justify-content: flex-start;\n  }\n\n  .dimensions-page .category-list {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 760px) {\n  .dimensions-page {\n    --page-gutter: 20px;\n  }\n\n  .dimensions-page .page-section {\n    padding-top: 60px;\n  }\n\n  .dimensions-page .page-hero {\n    padding-top: 40px;\n  }\n\n  .dimensions-page .hero-card {\n    padding: 34px 24px;\n    border-radius: 26px;\n  }\n\n  .dimensions-page .hero-lead {\n    font-size: 16px;\n  }\n\n  .dimensions-page .hero-aside {\n    grid-template-columns: 1fr;\n    justify-items: center;\n  }\n\n  .dimensions-page .hero-stat {\n    width: min(100%, 420px);\n    padding-top: 20px;\n    border-top: 1px solid var(--line);\n    text-align: center;\n  }\n\n  .dimensions-page .hero-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .dimensions-page .dim-btn-primary,\n  .dimensions-page .dim-btn-secondary {\n    width: 100%;\n  }\n\n  .dimensions-page .catalog-shell {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 520px) {\n  .dimensions-page .dimension-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dimensions-page .dimension-card {\n    min-height: 0;\n  }\n\n  .dimensions-page .hero-actions {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .dimensions-page .filters {\n    gap: 7px;\n  }\n\n  .dimensions-page .filter {\n    padding: 0 12px;\n  }\n\n  .dimensions-page .category-list {\n    grid-template-columns: 1fr;\n  }\n\n  .dimensions-page .catalog-section {\n    padding-bottom: 64px;\n  }\n}\n\n/* Nuevos estilos de V23 */\n.dimensions-page .verification-note {\n  margin: 0 2px;\n  color: #6b7972;\n  font-size: 10.5px;\n  line-height: 1.55;\n  max-width: 76ch;\n}\n.dimensions-page .verification-note strong {\n  color: #52675b;\n  font-weight: 750;\n}\n.dimensions-page .catalog-contact {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin-top: 24px;\n  padding: 18px 20px;\n  border: 1px solid rgba(130,177,148,.28);\n  border-radius: 18px;\n  background: rgba(130,177,148,.09);\n}\n.dimensions-page .catalog-contact-copy {\n  margin: 0;\n  color: var(--text-muted);\n  font-size: 13px;\n  line-height: 1.65;\n}\n.dimensions-page .catalog-contact-copy strong {\n  color: var(--text-main);\n}\n.dimensions-page .catalog-contact .dim-btn-secondary {\n  flex: 0 0 auto;\n  min-height: 40px;\n  padding: 0 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media(max-width:760px){\n  .dimensions-page .catalog-contact {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
